export default (params) => ({
  trigger: {
    name: 'insurance_selector.select_duration_pill',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      option_name: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'add_to_cart_overlay',
          'add_to_cart_page',
          'shopping_cart',
          'employee_atc_page',
          'employee_ato_page',
          'business_atc_page',
        ],
      },
    },
    event: {
      name: 'select_option',
      params: {
        total_indices: null,
        attribute: null,
        selection_type: null,
      },
    },
    nonInt: true,
  },
});
